/* eslint-disable */
import { MenuItem, Select } from "@mui/material";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";

const CustomEnumSelect = forwardRef(({name, list, labelName, isLabelView=true, onChange, ...restProps}, ref) => {
    const { t } = useTranslation();
    
    return (
        <Select
            {...restProps}
            ref={ref}
            MenuProps={{
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                },
                PaperProps: {
                    sx: {
                        transform: 'translateX(5px)',
                    },
                },
            }}
            sx={{
                minWidth: '90%' 
                , backgroundColor: "inherit"
                , "& .MuiOutlinedInput-notchedOutline>legend":{overflow:"unset"}
                , "& .MuiOutlinedInput-notchedOutline>legend>span":{opacity:"unset", color:"#fff",backgroundColor:"gray",borderRadius:"5px",position:"relative",top:"-5px"}
            }}
            onChange={onChange}
        >
            <MenuItem 
            sx={{display : `${isLabelView?'':'none'}`}}
            key="empty"
            value={''}>
                {labelName}
            </MenuItem>
            {list && list.map((opt) => (
            <MenuItem key={opt.code} value={opt.code}>
                {opt.titleKey?t(opt.titleKey):opt.title}
            </MenuItem> 
            ))}
        </Select>
    );
});

export default CustomEnumSelect;